"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconToggle = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var IconToggle = function (props) {
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: props.disabledMessage, show: props.disabled ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, position: kaleidoscope_1.TooltipPosition.Bottom },
        react_1.default.createElement("div", { className: "space-between space-stack-s" },
            react_1.default.createElement("div", { className: "icon-toggle" }, props.icon),
            react_1.default.createElement(kaleidoscope_1.Toggle, { label: props.label, value: props.value, onChange: props.onChange, disabled: props.disabled }))));
};
exports.IconToggle = IconToggle;
